module.exports = __webpack_public_path__ + "img/weixin-qrcode.6b27a749.jpg";